import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;
export const Main = styled.div`
  border-radius: 10px;
  height: 100%;
  background-color: rgba(217, 217, 217, 0.29);

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgb(217, 217, 217);
    z-index: 4;
  }
`;

export const Chat = styled.div`
  width: 100%;
  height: 88vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    height: 100%;
  }
`;
export const ChatNav = styled.div`
  height: 10%;
  display: flex;
  align-items: center;
  padding: 2px 10px 0 5px;
  justify-content: space-between;
  @media (max-width: 768px) {
    background-color: #fff;
    padding: 0 10px;
  }

  div:nth-child(1) {
    display: flex;
    gap: 10px;
    align-items: center;
    div:nth-child(1) {
      display: none;
      @media (max-width: 768px) {
        display: block;
      }
    }
    div:nth-child(2) {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 3px;
      transition: 0.3s ease;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
      }
      span {
        color: #000;
        font-weight: 600;
        text-transform: capitalize;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          width: 40vw;
        }
      }
      &:hover {
        background-color: #b8b8b862;
        width: fit-content;
        cursor: pointer;
        border-radius: 7px;
        @media (max-width: 768px) {
          border-radius: 0;
          background-color: transparent;
        }
      }
    }
  }

  div:nth-child(2) {
    display: flex;
    align-items: center;
    gap: 7px;

    div:nth-child(1) {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;

      &:hover {
        background-color: #b8b8b8c7;
        padding: 2px;
        border-radius: 20px;
      }
      @media (max-width: 768px) {
        display: none;
      }
      &:hover span:nth-child(1) {
        padding-left: 3px;
        display: block;
      }
      &:hover span:nth-child(2) {
        margin: 0;
      }
      span:nth-child(1) {
        border-radius: 5px;
        color: white;
        font-size: 10px;
        font-weight: 500;
        display: inline-block;
        white-space: nowrap;
        display: none;
        color: #000;
        transition: 0.3s ease;
      }
      span:nth-child(2) {
        border: 1px solid #b8b8b8;
        margin: 2px;
        text-align: center;
        display: flex;
        align-items: center;
        background: #fff;
        padding: 3px;
        border-radius: 20px;
        color: #000;
      }
    }
    div:nth-child(2) {
      background: #fff;
      border: 1px solid #b8b8b8;
      color: black;
      display: flex;
      align-items: center;
      padding: 3px;
      border-radius: 8px;
      gap: 0;
      /* display: none; */

      span:nth-child(2) {
        color: #b8b8b88a;
      }
      span:nth-child(1),
      span:nth-child(3) {
        border-radius: 5px;
        display: flex;
        align-items: center;
        text-align: center;
        padding: 5px 10px;
        font-size: 18px;
        &:hover {
          cursor: pointer;
          background: #b8b8b88a;
        }
      }
    }
    div:nth-child(3) {
      color: black;
      cursor: pointer;
      font-size: 18px;
      display: flex;
      align-items: center;
      text-align: center;
    }
  }
`;
export const ChatMessage = styled.div`
  height: 71%;
  overflow-y: scroll;
  padding: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;

  @media (max-width: 768px) {
    height: 100%;
    background-color: #f9f9f980;
  }

  &::-webkit-scrollbar {
    width: 2px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000ce;
    width: 2px;
    border-radius: 3px;
  }
`;
export const SenderMessage = styled.div`
  display: flex;
  align-items: end;
  justify-content: flex-end;
  div {
    border-radius: 5px;
    padding: 10px;
    background-color: #000;
    max-width: 70%;
    position: relative;
    margin-right: 10px;
    display: flex;
    gap: 2px;
    flex-direction: column;

    span:nth-child(1) {
      color: #fff;
      font-size: 16px;
    }
    span:nth-child(2) {
      font-family: "Eagle Lake", sans-serif;
      color: #d7d7d7;
      font-size: 10px;
      display: flex;
      justify-content: end;
      align-items: end;
      white-space: nowrap;
      text-transform: uppercase;
      pointer-events: none;
    }

    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      right: -9px;
      border-top: 10px solid #000;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
  }
`;
export const ReceiveMessage = styled.div`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  div {
    border-radius: 5px;
    padding: 10px;
    background-color: #b8b8b8;
    color: #000;
    max-width: 70%;
    position: relative;
    margin-left: 10px;

    span:nth-child(1) {
      color: #000;
      font-size: 16px;
    }
    span:nth-child(2) {
      font-family: "Eagle Lake", sans-serif;
      color: #4b4b4b;
      font-size: 10px;
      display: flex;
      justify-content: end;
      align-items: end;
      white-space: nowrap;
      text-transform: uppercase;
      pointer-events: none;
      font-weight: 600;
    }

    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: -9px;
      border-top: 10px solid #b8b8b8;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid transparent;
    }
  }
`;

export const ChatInputs = styled.div`
  height: auto;
  position: relative;
  @media (max-width: 768px) {
    background-color: #f9f9f980;
    width: 100%;
    height: auto;
  }
`;
export const InputContainer = styled.div`
  margin: 0 10px 10px 10px;
  background-color: #fff;
  display: flex;
  align-items: flex-end;
  padding: 10px;
  border-radius: 10px;
  gap: 10px;
  @media (max-width: 768px) {
    margin: 10px;
  }

  textarea {
    width: 100%;
    resize: none;
    vertical-align: top;
    max-height: 5rem;
    min-height: 1rem;
    border-radius: 5px;
    border: 0;
    outline: none;
    padding: 7px;
    background-color: rgba(217, 217, 217, 0.29);
    font-size: 16px;

    &::-webkit-scrollbar {
      width: 2px;
      border-radius: 3px;
      background-color: #00000020;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #000000ce;
      width: 2px;
      border-radius: 3px;
    }
    @media (max-width: 768px) {
      max-height: 2rem;
    }
  }
  div {
    width: 50px;
    height: 35px;
    border-radius: 40px;
    background: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media (max-width: 768px) {
      width: 55px;
      height: 40px;
    }
  }
`;

export const LockMsgDialog = styled.div`
  div {
    align-items: center;
    display: flex;
    flex-direction: column;

    p {
      padding: 2px 10px;
      color: #3c3c43;
      border: 1px solid #dedede;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      width: fit-content;
      background: #fff;
      text-transform: capitalize;
    }
    div {
      flex-direction: row;
      padding: 10px 20px;
      width: fit-content;
      border: 1px solid #dedede;
      border-radius: 5px;
      background: #fff;
      display: flex;
      align-items: center;
      gap: 10px;
      @media (max-width: 768px) {
        width: 200px;
      }
      span {
        font-size: 14px;
        color: #3c3c43;
        text-align: center;
        @media (max-width: 768px) {
          font-size: 12px;
        }
      }
    }
  }
`;
export const BottomBtn = styled.div`
  background: #000000a0;
  color: #fff;
  padding: 5px 5px 2px 5px;
  position: fixed;
  right: 20px;
  bottom: 20%;
  border-radius: 30px;
  border: 1px solid #ffffffaf;
  z-index: 5;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    bottom: 15%;
  }
`;

export const EmojiContainer = styled.div`
  border-radius: 7px;
  width: 35%;
  display: flex;
  padding: 5px 0;
  flex-direction: column;
  box-shadow: 1px 1px 10px #1515155f;
  position: absolute;
  z-index: 5;
  background: rgb(217, 217, 217);
  bottom: 16%;

  @media (max-width: 500px) {
    bottom: 12%;
    width: 96%;
    left: 2%;
  }

  @media (width: 540px) {
    width: 70%;
    bottom: 15%;
    /* left: 2%; */
  }
  @media (width: 820px) {
    width: 50%;
    bottom: 25%;
  }
`;
export const EmojiSearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #0000003b;

  input {
    width: 100%;
    border: 0;
    outline: none;
    font-size: 16px;
    background-color: transparent;
    &::placeholder {
      font-size: 14px;
    }
  }
`;
export const EmojiSearch = styled.div`
  padding: 5px 10px;

  div:nth-child(2) {
    height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
    &::-webkit-scrollbar {
      width: 3px;
      border-radius: 3px;
      background-color: #00000020;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #000000bd;
      width: 3px;
      border-radius: 3px;
    }
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 35px;
    width: 35px;
    cursor: pointer;
    border: 1px solid #a8a4a498;
    border-radius: 5px;
    span {
      font-size: 22px;
    }
  }
`;

export const EmojiSearchDisplay = styled.div``;

export const EmojiNotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
`;

export const EmojiCategory = styled.div`
  padding: 5px 10px;
  height: 200px;
  overflow-y: scroll;
  background-color: #ffffff31;

  &::-webkit-scrollbar {
    width: 3px;
    border-radius: 3px;
    background-color: #00000020;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #000000bd;
    width: 3px;
    border-radius: 3px;
  }
  span {
    text-transform: capitalize;
  }
  div {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 35px;
      width: 35px;
      cursor: pointer;
      border: 1px solid #a8a4a498;
      font-size: 22px;
      border-radius: 5px;

      &:hover {
        background-color: #cacacaaa;
      }
    }
  }
`;
export const EmojiNavigator = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  gap: 3px;
  justify-content: space-around;
  button {
    width: 100%;
    font-size: 20px;
    padding-top: 5px;
    outline: none;
    color: #888;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 5px;

    &:hover {
      border: 1px solid #888;
      color: #000;
    }
    &:focus {
      color: #fff;
      background-color: #000;
    }
  }
`;
